import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');
    setCargando(true);

    try {
      await authAPI.forgotPassword({ email });
      setMensaje('Se ha enviado un correo con instrucciones para restablecer tu contraseña.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setError('No se encontró una cuenta con ese email.');
      console.error('Error al recuperar contraseña:', error);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo-rv-azul.png" alt="RV Logo" />
        </div>
        <h1 className="auth-title">Recuperar contraseña</h1>
        
        <p className="auth-subtitle">
          Ingresa tu email y te enviaremos instrucciones para restablecer tu contraseña
        </p>

        {error && <div className="auth-error">{error}</div>}
        {mensaje && <div className="auth-success">{mensaje}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="email"
            placeholder="Email*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-input"
          />

          <button type="submit" className="auth-button" disabled={cargando}>
            {cargando ? 'Enviando...' : 'Enviar instrucciones'}
          </button>
        </form>

        <div className="auth-back-link">
          <Link to="/login" className="auth-link">← Volver al inicio de sesión</Link>
        </div>
      </div>

      <button className="auth-book-btn" onClick={() => { window.location.href = 'https://rodrigovillanuevallanos.com/libro'; }}>
        Más del libro aquí
      </button>
    </div>
  );
};

export default ForgotPassword;

